// Declare dataLayer as a global variable
declare global {
  interface Window {
    dataLayer: any[];
  }
}

// Initialize dataLayer if it doesn't exist
window.dataLayer = window.dataLayer || [];

// Push events to dataLayer
export const pushEvent = (event: {
  event: string;
  category?: string;
  action?: string;
  label?: string;
  value?: number;
  [key: string]: any;
}) => {
  window.dataLayer.push(event);
};

// Common event types
export const GTMEvents = {
  // Page view events
  PAGE_VIEW: 'page_view',
  
  // User engagement events
  SIGN_UP: 'sign_up',
  SIGN_IN: 'sign_in',
  SIGN_OUT: 'sign_out',
  
  // Form events
  FORM_START: 'form_start',
  FORM_COMPLETE: 'form_complete',
  FORM_ERROR: 'form_error',
  
  // Document events
  DOCUMENT_UPLOAD: 'document_upload',
  DOCUMENT_DOWNLOAD: 'document_download',
  
  // Application events
  APPLICATION_START: 'application_start',
  APPLICATION_COMPLETE: 'application_complete',
  APPLICATION_SUBMIT: 'application_submit',
  
  // Conversion events
  PURCHASE: 'purchase',
  PACKAGE_SELECT: 'package_select',
} as const;

// Example usage:
/*
pushEvent({
  event: GTMEvents.SIGN_UP,
  category: 'User',
  action: 'Registration',
  label: 'Email Signup'
});

pushEvent({
  event: GTMEvents.PURCHASE,
  category: 'Ecommerce',
  action: 'Transaction',
  value: 999,
  currency: 'PLN',
  package_type: 'Premium'
});
*/ 